<template>
  <div>
    <el-upload
      drag
      :multiple="false"
      :auto-upload="false"
      :on-exceed="handleExceed"
      :on-success="successfield"
      :on-error="errorfield"
      :on-change="handleChange"
      action
      :limit="1"
      :http-request="uploadFile"
      :before-upload="beforeUpload"
      show-file-list
    >
      <i class="el-icon-upload"></i>
      <div class="el-upload__text " style="margin-left:83px">
        将文件拖到此处，或<em>选择文件</em>
      </div>
      <div class="el-upload__tip " slot="tip">
        只能上传xls/xlsx文件，且不超过500kb
      </div>
    </el-upload>
    <div class="flex_end" style="margin-top:20px">
      <el-button size="small" @click="closeDialog">取 消</el-button>
      <el-button size="small" @click="temp">模板下载</el-button>
      <el-button size="small" type="primary" @click="uploadFile(fileData)"
        >上传</el-button
      >
    </div>
  </div>
</template>
<script>
export default {
  props: {
    url: String,
    tempurl: String,
    tempTitle: String,
  },
  data() {
    return {
      fileData: null,
    };
  },
  mounted() {},
  methods: {
    temp() {
      this.$downloadAFile(
        { url: this.tempurl, data: {} },
        this.$getCurrentDate() + this.tempTitle
      );
    },
    /*  文件上传 start*/

    uploadFile(data) {
      let fd = new FormData();
      fd.append("file", data);

      this.$uploadFileAxios(
        {
          url: this.url, //新增，修改，
          data: fd,
        },
        (data) => {
          this.$success("操作成功!");

          this.closeDialog();
        }
      );
    },
    handleExceed(files, fileList) {
      this.$message.warning(`当前限制选择 1 个文件,添加失败`);
    },
    handleChange(file, fileList) {
      if (file && fileList.length == 1) {
        this.$message.success(`文件添加成功`);
        this.fileData = file.raw;
      } else if (file && fileList.length > 1) {
        this.$message.warning(`当前限制选择 1 个文件,添加失败`);
      }
    },
    beforeUpload(file) {
      let type = file.name.substring(file.name.lastIndexOf(".")); //截取获得后缀名
      let size = file.size / 1024 / 1024 < 500;

      if (!size) {
        this.$message.error(`导入的文件大小超过500MB`);
        return false;
      }
      if ([".xls", ".xlsx"].indexOf(type) >= 0) {
        return true;
      } else {
        this.$message.error("不支持此类文件格式!");
        return false;
      }
    },
    errorfield(err, file, fileList) {
      this.$message.error("文件上传失败!");
    },
    successfield(response, file, fileList) {
      if (response.status == "200") {
        this.$message.success("操作成功!");
      } else {
        this.$message.error("操作失败!");
      }
    },
    /*  文件上传 end*/

    //222
  },
};
</script>
<style scoped></style>
